import { render, staticRenderFns } from "./Carrier.vue?vue&type=template&id=87044bf0"
import script from "./Carrier.vue?vue&type=script&lang=js"
export * from "./Carrier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports